import { getCommonStyle } from '../styleCommon';
import { getMarkerStyles } from '../marker';

export function getRSIStyles() {

	const commonLineWidth = getCommonStyle('line.width');
	const commonYAxisPaddingBottom = getCommonStyle('panel.yAxisPadding.bottom');
	const commonYAxisPaddingTop = getCommonStyle('panel.yAxisPadding.top');
	const commonSessionBreak = getCommonStyle('sessionBreak');
	const marker = getMarkerStyles();

	return {
		color: '#17510A',
		lineDash: '',
		overbought: marker.band,
		oversold: marker.band,
		width: commonLineWidth,
		yAxisPadding: {
			bottom: commonYAxisPaddingBottom,
			top: commonYAxisPaddingTop
		},
		sessionBreak: commonSessionBreak
	};
}
